export default __webpack_public_path__ + "static/media/298d35cbc717ef637ab72e974b7022d7.svg";